
import Vue from "vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { mapActions } from "vuex";
import Modal from "~/components/Modal.vue";
import LargeSelect from "~/components/form/LargeSelect.vue";
import Claim from "~/entities/Claim";
import Notice from "~/entities/Notice";
import Validation from "~/entities/Validation";
import ValidationClaim from "~/entities/ValidationModules/ValidationClaim";
import * as Sentry from "@sentry/vue";

interface OptionI {
  label: string;
  value: boolean | string;
}

interface SelectionI {
  name: string;
  option: {
    label: string;
    value: boolean | string;
  };
}

export default Vue.extend({
  data() {
    return {
      PhoneValidationRules: {
        inputOptions: {
          placeholder: "",
          required: true,
          maxlength: 20,
        },
        validCharactersOnly: true,
        mode: "international",
        dropdownOptions: {
          disabled: false,
          showDialCodeInList: true,
          showDialCodeInSelection: false,
          showFlags: true,
          showSearchBox: true,
          tabindex: 0,
          width: "390px",
        },
      },
      validation: new Validation(new ValidationClaim()),
      isValidPhone: false as boolean,
      reason: "",
      firstOrderCheck: false as boolean,
      firstTrackingCheck: false as boolean,
      isValidTrackingId: false as boolean,
      isValidOrderId: false as boolean,
      claimForm: new Claim() as Claim,
      showAlert: false as boolean,
      description: "" as string,
      submitting: false as boolean,
      rejectedEmail: false as boolean,
      urlImage: "bf-red-x-mark-2x.png",
      activeWarning: false as boolean,
      title: "Claims",
      isOpen: false as boolean,
      recipentOptions: [
        { label: "I am the sender of this package.", value: true },
        { label: "I am the recipient of this package.", value: false },
      ] as OptionI[],
      damageOptions: [
        { label: "Loss", value: "loss" },
        { label: "Damage", value: "damage" },
        { label: "Missing Contents", value: "missing content" },
      ] as OptionI[],
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "claimsform",
          name: "claimsform",
          content: "",
        },
      ],
    };
  },
  components: {
    VueTelInput,
    Modal,
    LargeSelect,
  },
  mounted() {
    (this as any).validation.module.component = this;
  },

  computed: {},
  methods: {
    ...mapActions({
      createClaim: "createClaim",
      clearActiveNotices: "errorsBag/clearActiveNotices",
      clearAlertResponses: "errorsBag/clearAlertResponses",
    }),

    selectionMade(selection: SelectionI) {
      this.claimForm[selection.name] = selection.option.value;
    },

    imageThumbnail(image) {
      const pdfThumbnail =
        "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1213.62 1430.25'%3E%3Cpath d='M1290,285H508.13a61.87,61.87,0,0,0-61.88,61.88V1653.13A61.87,61.87,0,0,0,508.13,1715h983.75a61.87,61.87,0,0,0,61.87-61.87V548.75Z' transform='translate(-340.26 -284.88)' style='fill:%23fff;stroke:%23000;stroke-miterlimit:10;stroke-width:2.25px'/%3E%3Cpath d='M1290,486.88a61.87,61.87,0,0,0,61.88,61.87h201.87L1290,285Z' transform='translate(-340.26 -284.88)' style='fill:%23f1f2f2'/%3E%3Cpolygon points='10 483.6 105.94 579.55 105.94 483.6 10 483.6' style='fill:%23858a93'/%3E%3Crect y='235.38' width='674.97' height='258.74' rx='34.99' style='fill:%239ca3af'/%3E%3Crect x='265.99' y='692.63' width='787.5' height='80' style='fill:%23f1f2f2'/%3E%3Crect x='265.99' y='842.63' width='787.5' height='80' style='fill:%23f1f2f2'/%3E%3Crect x='265.99' y='992.63' width='787.5' height='80' style='fill:%23f1f2f2'/%3E%3Crect x='265.99' y='1142.63' width='787.5' height='80' style='fill:%23f1f2f2'/%3E%3Cpath d='M480.66,735.78V563.46h65q17.16,0,26.22,1.64,12.69,2.11,21.27,8.06A42.22,42.22,0,0,1,607,589.79a52.75,52.75,0,0,1,5.23,23.51q0,22-14,37.2t-50.55,15.22H503.47v70.06Zm22.81-90.39H548q22.11,0,31.39-8.23T588.68,614q0-10.82-5.46-18.51a25.63,25.63,0,0,0-14.4-10.17q-5.76-1.53-21.28-1.53H503.47Z' transform='translate(-340.26 -284.88)' style='fill:%23fff'/%3E%3Cpath d='M641.23,735.78V563.46h59.36q20.1,0,30.68,2.47a58.33,58.33,0,0,1,25.27,12.34,70.1,70.1,0,0,1,20.39,29.44q6.77,17.92,6.76,41,0,19.64-4.58,34.79t-11.76,25.1a62.46,62.46,0,0,1-15.69,15.63,64,64,0,0,1-20.57,8.64,117.33,117.33,0,0,1-27.68,2.94ZM664,715.44h36.79q17,0,26.74-3.17T743,703.34q8.12-8.12,12.64-21.81t4.52-33.2q0-27-8.87-41.56t-21.57-19.45q-9.16-3.52-29.51-3.53H664Z' transform='translate(-340.26 -284.88)' style='fill:%23fff'/%3E%3Cpath d='M816.25,735.78V563.46H932.5v20.33H839.05v53.37h80.88v20.33H839.05v78.29Z' transform='translate(-340.26 -284.88)' style='fill:%23fff'/%3E%3C/svg%3E%0A";
      return image.type === "application/pdf"
        ? pdfThumbnail
        : URL.createObjectURL(image);
    },

    isValidEmail() {
      let validEmail = this.$refs.input as HTMLInputElement;
      return validEmail ? validEmail.checkValidity() : false;
    },

    validatePhone(eventData) {
      // Validate the input element within the vue-tel-input component
      this.isValidPhone = !!eventData.valid;
    },

    closeModal() {
      this.isOpen = false;
    },
    showModal() {
      this.isOpen = true;
    },

    async checkOrderId() {
      try {
        const response = await this.$axios(
          `${this.$config.apiURL}/api/Claim/valid-order/${this.claimForm.OrderId}`,
          {
            method: "head",
          }
        ).catch(() => {
          this.isValidOrderId = false;
        });
        if (response && response.status === 200) {
          this.isValidOrderId = true;
        }
      } catch (e) {
        Sentry.captureException(e);
      }
      this.firstOrderCheck = true;
    },

    async checkTrackingId() {
      try {
        const response = await this.$axios(
          `${this.$config.apiURL}/api/Claim/valid-tracking/${this.claimForm.TrackingNumber}`,
          {
            method: "head",
          }
        ).catch(() => {
          this.isValidTrackingId = false;
        });
        if (response && response.status === 200) {
          this.isValidTrackingId = true;
        }
      } catch (e) {
        Sentry.captureException(e);
      }
      this.firstTrackingCheck = true;
    },

    async submitClaim() {
      const claim = await this.createClaim(this.claimForm);
      this.closeModal();

      if (claim) {
        switch (claim.status) {
          case 400:
            this.showAlert = true;
            this.description =
              "We were unable to find or verify your order please contact support at support@bikeflights.com.";
            break;
          case 500:
            this.showAlert = true;
            this.description =
              "Something went wrong with your claims submission please contact support at support@bikeflights.com.";
            break;
          default:
            this.showAlert = true;
            this.urlImage = "bf-blue-check-mark-2x.png";
            this.description =
              "Your claim has been submitted and is being processed by our support team. Confirmation has been emailed to: " +
              this.claimForm.Email +
              ". For claims regarding damage or missing contents, please retain the merchandise and original packaging until the claim is resolved.";
            break;
        }
      } else {
        this.showAlert = true;
        this.description =
          "Something went wrong with your claims submission please contact support at support@bikeflights.com.";
      }
    },
    async submit() {
      this.submitting = true;
      this.firstOrderCheck = true;
      this.firstTrackingCheck = true;

      const valid = (this as any).validation.Validate("claim");

      if (valid) {
        if (!this.isValidTrackingId) {
          this.activeWarning = true;
        } else if (
          !this.claimForm.EstimatePics?.length ||
          this.claimForm.EstimatePics?.length === 0
        ) {
          this.isOpen = true;
        } else {
          await this.submitClaim();
        }
      } else {
        this.activeWarning = true;
      }
      this.submitting = false;
    },
    async uploadFile(image: any, type: string) {
      let file = image.files;
      let keepFiles: any[] = this.claimForm[type] ? this.claimForm[type] : [];
      if (file.length > 0 && keepFiles.length < 3) {
        const heic2any = require("heic2any");

        if (file[0].type === "image/heic") {
          const heic2any = require("heic2any");

          await heic2any({
            blob: file[0],
            toType: "image/jpeg",
          }).then(
            (blob) => {
              const newFileName = file[0].name.split(".")[0] + ".jpg";
              keepFiles.push(
                new File([blob], newFileName, {
                  type: "image/jpeg",
                })
              );
            },
            (error) => {
              //handle errors
            }
          );
        } else {
          keepFiles.push(file[0]);
        }

        Vue.set(this.claimForm, type, keepFiles);
      }
    },
  },
});
